import { ReactNode, createContext, useContext, useMemo, useState } from "react";

interface TDProviderProps {
    children: ReactNode;
}

interface TDContextData {
    check: boolean;
    setCheck: (arg0: boolean) => void;
    justification: string;
    setJustification: (arg0: string) => void;
}

export const TachDocumentContext = createContext<TDContextData>(
    {} as TDContextData
);

export function TachDocumentProvider({ children }: TDProviderProps) {
    const [check, setCheck] = useState<boolean>(false);
    const [justification, setJustification] = useState<string>("");

    const contextValue = useMemo(
        () => ({
            check,
            setCheck,
            justification,
            setJustification,
        }),
        [check, justification]
    );

    return (
        <TachDocumentContext.Provider value={contextValue}>
            {children}
        </TachDocumentContext.Provider>
    );
}

TachDocumentContext.displayName = "TachDocWorkflow";

export function useTachDocWorkflow() {
    return useContext(TachDocumentContext);
}
